<template>
    <div class="error-wrap full-screen-popup">
        <img :src="dataImage" v-if="dataImage"/>
        <p v-if="dataTitle" class="fs-16 medium color-slaty-dark">{{ dataTitle }}</p>
        <p v-if="dataSubTitle" class="fs-14 color-slaty-dark">{{ dataSubTitle }}</p>
        <button v-if="dataCta" class="line-btn major w100 mt16" v-on:click="ctaTriggered()">{{ dataCta }}</button>
    </div>
</template>
<script>
export default {
    name:"ErrorScreen",
    props: [
    "dataTitle",
    "dataImage",
    "dataSubTitle",
    "dataCta"
  ],
  methods:{
    ctaTriggered(){
        if(dataCta.toLowerCase() == 'try again')
        this.$emit('reloadPage');
    }
  }

}
</script>
